<template>
    <router-view/>
</template>
<script>
import { mapMutations } from 'vuex';

export default {
  created() {
    const token = localStorage.getItem('token');
    const userID = localStorage.getItem('userID');
    const userEmail = localStorage.getItem('userEmail');
    const role = localStorage.getItem('role');
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    const logoutFlag = localStorage.getItem('logoutFlag');
    const permission = JSON.parse(localStorage.getItem('permission'));
    this.setAuthenticated(isAuthenticated);
    this.setLogoutFlag(logoutFlag);
    this.setUserEmail(userEmail);
    this.setUserID(userID);
    this.setToken(token);
    this.setPermission(permission);
    this.setRole(role);
  },
  mounted(){
    window.addEventListener('storage', this.handleLogoutEvent);
  },
  errorCaptured(error) {
    console.error(error);
    localStorage.setItem('errorFlag', true);
    this.$router.push({ name: 'errorPage' });
    return false;
  },
  methods: {
    ...mapMutations(['setAuthenticated', 'setUserEmail', 'setUserID', 'setToken', 'setLogoutFlag', 'setPermission', 'setRole']),
    handleLogoutEvent(event) {
        if (event.key === localStorage.getItem('logoutEventKey')) {
            this.$store.dispatch('logout');
            this.$router.push({ name: 'login' });
            document.title = "ログイン";
            localStorage.removeItem('logoutEventKey');
        }
    }
  },
};
</script>